interface StatCardProps {
  title: string;
  value: string;
}

export function StatCard({ title, value }: StatCardProps) {
  return (
    <div className="rounded-xl border border-navy-700 bg-navy-800 p-5">
      <p className="mb-1 text-sm text-navy-300">{title}</p>
      <p className="text-2xl font-bold text-white">{value}</p>
    </div>
  );
}
